import { Nullable } from '@/utils/types';

// `/3/property/12?tab=x` -> 3; non-account paths such as `/oauth/authorize?...` have none
const ACCOUNT_PATH = /^\/(\d+)(?:[/?#]|$)/;

/**
 * The page saved before sign-in, if it belongs to the account the user signed into.
 * A page of another account would switch the user back to that account, so it is dropped
 * and the caller falls back to the dashboard of the chosen account.
 */
export const getReturnUrlForAccount = (url: Nullable<string>, accountId: number): Nullable<string> => {
  if (!url) {
    return null;
  }

  const match = url.match(ACCOUNT_PATH);

  if (match && Number(match[1]) !== accountId) {
    return null;
  }

  return url;
};
